import gql from 'graphql-tag';

export const ADD_SUPER_PROFILE_MUTATION = gql`
  mutation addSuperProfileMutation($input: AddSuperProfileInput!) {
    addSuperProfile(input: $input) {
      id
    }
  }
`;

export const CONFIG_QUERY = gql`
  query configQuery($accountId: ID!) {
    availableCountries
    activeLocales
    account(id: $accountId) {
      id
      greatFullSpectrumJobProfiles {
        id
        name
      }
    }
  }
`;

export const JOB_PROFILES_QUERY = gql`
  query jobProfilesQuery($accountId: ID!, $first: Int!, $filter: JobProfileFilter, $sort: JobProfileSortSpecifier) {
    account(id: $accountId) {
      id
      jobProfiles(first: $first, filter: $filter, sort: $sort) {
        edges {
          node {
            id
            name
            internalDescription
            assessmentTemplate {
              id
            }
          }
        }
      }
    }
  }
`;

export const SUPER__PROFILES_QUERY = gql`
  query superProfilesQuery($accountId: ID!) {
    account(id: $accountId) {
      superProfiles {
        id
        internalName
        publicTitle
        publicDescription
        jobProfile {
          name
          assessmentTemplate {
            title
          }
        }
        createdOn
        updatedOn
        active
      }
    }
  }
`;

export const UPDATE_SUPER_PROFILE_STATUS_MUTATION = gql`
  mutation updateSuperProfileStatusMutation($input: UpdateSuperProfileStatusInput!) {
    updateSuperProfileStatus(input: $input)
  }
`;

export const SUPER_PROFILE_DETAILS_QUERY = gql`
  query superProfileDetailsQuery($accountId: ID!, $superProfileId: ID!) {
    availableCountries
    activeLocales
    account(id: $accountId) {
      greatFullSpectrumJobProfiles {
        id
        name
      }
      superProfile(id: $superProfileId) {
        id
        internalName
        publicTitle
        publicDescription
        occupationalLevel
        workCategory
        workArea
        workplaceDetails {
          type
          officeOnlyWorkplaceDetailsData {
            country
            regions
          }
          officeAndRemoteWorkplaceDetailsData {
            country
            regions
          }
          remoteOnlyWorkplaceDetailsData {
            fromAnyCountry
            countries
          }
        }
        jobProfile {
          id
        }
        requiredMinimumEducation
        educationRelevance
        requiredJobSeniority
        jobSeniorityRelevance
        requiredManagementExperience
        requiredLanguageProficiencies {
          language
          proficiency
        }
        minimumOverallAssessmentScoreRequired
        minimumOverallQAndRScoreRequired
      }
    }
  }
`;

export const UPDATE_SUPER_PROFILE_MUTATION = gql`
  mutation updateSuperProfileMutation($input: UpdateSuperProfileInput!) {
    updateSuperProfile(input: $input) {
      id
    }
  }
`;

export const DELETE_SUPER__PROFILE = gql`
  mutation deleteSuperProfileMutation($input: DeleteSuperProfileInput!) {
    deleteSuperProfile(input: $input)
  }
`;
